<div fxFlex fxFill style="padding: 2rem 10rem;" class="appAdminContainer">
  <router-outlet></router-outlet>
</div>
